export default __webpack_public_path__ + "static/media/landfill.bf0c8ef0.svg";